<style scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
}

.toolbar {
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 20px;
}

.timeline {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>

<template>
  <div class="main" ref="main">
    <v-chip-group class="toolbar">
      <v-chip color="#86B404" small v-on:click="fit">fit</v-chip>
    </v-chip-group>
    <div ref="visualization" class="timeline"></div>
  </div>
</template>

<script>
import vis from "vis-timeline/dist/vis-timeline-graph2d.min"
import "vis-timeline/dist/vis-timeline-graph2d.css"

import { getHTMLElementDimensions } from "@/helpers/index"

export default {
  name: 'visual-timeline',
  props: {
    incomingEvents: {
      Array, default: function () {
        return [
          { id: 1, content: 'item 1', start: '2014-04-20' },
          { id: 2, content: 'item 2', start: '2014-04-14' },
          { id: 3, content: 'item 3', start: '2014-04-18' },
          { id: 4, content: 'item 4', start: '2014-04-16', end: '2014-04-19' },
          { id: 5, content: 'item 5', start: '2014-04-25' },
          { id: 6, content: 'item 6', start: '2014-04-27', type: 'point' }
        ]
      }
    },
    incomingData: { Array, default: null },
  },
  components: {},
  data: () => ({
    timeline: null
  }),
  watch: {
    incomingEvents() {
      console.log("new events in Visual TImeline component")
      console.log(this.incomingEvents)
      this.renderTimeline();
    }
  },
  mounted() {
    this.renderTimeline()
  },
  methods: {
    fit() {
      this.timeline.fit()
    },
    clickEvent(properties) {
      this.$emit("clickEvent", properties)
    },
    renderTimeline() {
      let container = this.$refs.visualization;
      let dimensions = getHTMLElementDimensions(container);
      let items = new vis.DataSet(this.incomingEvents);
      var options = {
        autoResize: true,
        maxHeight: dimensions.height,
        minHeight: dimensions.height,
        cluster: false,
        verticalScroll: true,
        selectable: false,
        showWeekScale: true
      };
      if (this.timeline) {
        this.timeline.destroy();
      }
      this.timeline = new vis.Timeline(container, items, options);
      this.timeline.range.options.min =  new Date(1900, 0, 1);
      this.timeline.range.options.max = new Date(2100, 0, 1);
      this.timeline.on('click', (properties) => {
        if (properties.item || properties.items) {
          this.clickEvent(properties)
        }
      });


    }


  }
}
</script>
